import clsx from "clsx";
import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import styles from "./styles";

const InfoCard = ({uid, isNewDesign, info_text, classes, cardType, children}) => {
  const iconClassName = {
    'warning': 'fal fa-exclamation-circle'
  }[cardType] || 'far fa-info-circle';

  return (
    <div className={clsx(classes.stepInfoText, isNewDesign && 'newDesign', cardType)} data-id={`${uid}-info`}>
      <span className={clsx('fa-icon', iconClassName)} />
      {!isNewDesign && <>&nbsp;</>}
      {info_text}
      {children}
    </div>
  )
};

InfoCard.defaultProps = {
  cardType: 'info'
};

export default withStyles(styles)(InfoCard);